import { columnForField, defaultColumnWidth } from "../../../Grid/columnForField";
import { kendoDateCell } from "../../../Layout/Grid/Cell/DateCell";
import {
  controlDepartmentTypeColumnMenu,
  controlDepartmentTypeEnumCell,
} from "../ControlDepartmentTypeGridColumn";
import { kendoDefaultDateFormatddMMyyyy } from "../../../Utils/dates";
import { ProposedFtlRoute } from "./ProposedFtlRoute";
import { returnLaunchDateCell } from "./ReturnLaunchDateCell.custom";
import { launchDateCell } from "./LaunchDateCell.custom";

type Props = {
  handleLaunchDateChange: (route: ProposedFtlRoute) => void;
};

export const proposedFtlRouteGridColumns = ({ handleLaunchDateChange }: Props) => {
  return [
    columnForField<ProposedFtlRoute>("RouteNumber", {
      title: "Route Number",
      width: defaultColumnWidth,
    }),
    columnForField<ProposedFtlRoute>("Destination", {
      title: "Destination Name",
      width: "300px",
    }),
    columnForField<ProposedFtlRoute>("LaunchClassification", {
      title: "Launch Classification",
      hideFilterCell: true,
      columnMenu: controlDepartmentTypeColumnMenu,
      cell: controlDepartmentTypeEnumCell,
      width: defaultColumnWidth,
    }),
    columnForField<ProposedFtlRoute>("CarrierName", {
      title: "Carrier Name",
      width: "200px",
    }),
    columnForField<ProposedFtlRoute>("CarrierBranch", {
      title: "Carrier Branch",
      width: "200px",
    }),
    columnForField<ProposedFtlRoute>("ControlType", {
      title: "Control Type",
      width: defaultColumnWidth,
    }),
    columnForField<ProposedFtlRoute>("LaunchDate", {
      title: "Launch Date",
      filter: "date",
      editor: "date",
      editable: true,
      cell: (props) =>
        launchDateCell({
          gridCellProps: props,
          handleDateChange: handleLaunchDateChange,
        }),
      format: `{0:${kendoDefaultDateFormatddMMyyyy}}`,
      width: defaultColumnWidth,
    }),
    columnForField<ProposedFtlRoute>("ReturnLaunchDate", {
      title: "Return Launch Date",
      filter: "date",
      cell: (props) =>
        returnLaunchDateCell({
          gridCellProps: props,
          handleDateChange: handleLaunchDateChange,
        }),
      width: defaultColumnWidth,
    }),
    columnForField<ProposedFtlRoute>("ProjectName", {
      title: "Project Name",
      width: "300px",
    }),
    columnForField<ProposedFtlRoute>("ActionStartDate", {
      title: "Action Start Date",
      filter: "date",
      cell: kendoDateCell(),
      width: defaultColumnWidth,
    }),
  ];
};
